import { HotelRateDisplayPreferences } from '../../constants';

const getHotelPriceDisplayPreference = (doGetUserSelectedValue = false) => (store) => {
  const { isViewingBrochure } = store.brochure;
  const { isViewingCompare } = store.compare;

  let pricePreference;
  if (!doGetUserSelectedValue
    && isViewingBrochure && Object.values(store.brochure.brochures || {}).length > 0) {
    pricePreference = Object.values(store.brochure.brochures || {})[0].hotelRateDisplayPreference;
  } else if (!doGetUserSelectedValue
    && isViewingCompare && store.compare.hotelRateDisplayPreference !== undefined
    && store.compare.hotelRateDisplayPreference !== null) {
    pricePreference = store.compare.hotelRateDisplayPreference;
  } else {
    pricePreference = store.tripSearch.hotelPriceDisplayPreference;
  }
  const hotelRateDisplayPreference = (store && store.user
  && store.user.travelAgency && store.user.travelAgency.settings
  && store.user.travelAgency.settings.hotelRateDisplayPreference) || undefined;
  const defaultVal = hotelRateDisplayPreference
    ? Number(hotelRateDisplayPreference) : HotelRateDisplayPreferences.TotalRate;
  return pricePreference !== null && pricePreference !== undefined
  && pricePreference >= 0 ? pricePreference : defaultVal;
};
export default getHotelPriceDisplayPreference;
